import { createTermsTagsManager } from '../../utils/createTermsTagsManager';
import { GARAGE_KINDS_MAP_VALUE_TO_LABEL } from './constants';

export const garageKindTagsManager = createTermsTagsManager({
  jsonQueryKey: 'garage_garage_type',
  mapValueToLabel: GARAGE_KINDS_MAP_VALUE_TO_LABEL,
  id: 'garageKind',
});
